import { HttpClient, HttpMethods } from "@planzone/services";

function removeChatConversation(httpClient: HttpClient) {
  return (conversationId: string) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/secured/conversations/${conversationId}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve());
}

export { removeChatConversation };
